/*eslint-disable*/
import { useEffect } from 'react';

let useEventListener = (key, handler, options) => {
    useEffect(() => {
        window.addEventListener(key, handler, options);
        return () => {
            window.removeEventListener(key, handler, options);
        };
    });
};

export let eventDispatch = (key, detail) => {
    window.dispatchEvent(new CustomEvent(key, { detail }));
};

export default useEventListener;
/*eslint-enable*/
